import { getSmsConsent } from "../../services/api";
import { useSmsConsentStore } from "../../store/useSmsConsentStore";
import { smsConsentNeedsAutoPrompt } from "./smsConsentPrompt";

let inflight: Promise<void> | null = null;

/**
 * Loads the SMS consent text for the preferences switch.
 * True when the popup is now pending. False when SMS is not offered or
 * this version already has a Yes: the caller saves the switch itself.
 */
export async function requestSmsConsent(
  linkId: string,
  lang: string,
): Promise<boolean> {
  try {
    const consent = await getSmsConsent(linkId, lang);
    if (!consent.available || !consent.version) return false;
    if (consent.current === "accepted") return false;
    useSmsConsentStore.getState().setPending(consent);
    return true;
  } catch {
    return false;
  }
}

/**
 * Shows the consent popup when this version has no answer, and resolves
 * when the user answers or the save fails. A missing offer or a failed
 * load resolves immediately so the operation can continue.
 */
export function ensureSmsConsent(linkId: string, lang: string): Promise<void> {
  if (inflight) return inflight;
  inflight = runEnsure(linkId, lang).finally(() => {
    inflight = null;
  });
  return inflight;
}

async function runEnsure(linkId: string, lang: string): Promise<void> {
  try {
    const consent = await getSmsConsent(linkId, lang);
    if (!smsConsentNeedsAutoPrompt(consent)) return;
    await new Promise<void>((resolve) => {
      useSmsConsentStore.getState().setPending(consent, {
        source: "gate",
        settle: resolve,
      });
    });
  } catch {
    return;
  }
}
